

























































































































import { Component, Watch } from 'vue-property-decorator';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { actionsEvent } from '@/setup';

import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Confirmation from '@/components/Confirmation.vue';

import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';

import {
  ParamsApi,
  ClearParam,
  MsgParam,
  IdParams,
  DataApi,
  FiltersApi,
} from './models/AtencionesBase.model';

import AtencionesModalVerDetalle from './AtencionesModalVerDetalle.vue';

import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import { fetchAtenciones } from './fetchAtenciones';
import PopUpGeneratedReports from './PopUpGeneratedReports.vue';
import { getUserId } from '../MantenedorLocalidad/helpers/getUserId';

@Component({
  components: {
    FormFieldsContainer,
    DatePicker,
    Confirmation,
    MantenedorGridSinCodigo,
    AtencionesModalVerDetalle,
    PopUpGeneratedReports,
  },
})
export default class AtencionesBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.Atenciones;

  verDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };

  anular: PermisoAccion = {
    accionCodigo: 94,
    visible: false,
  };

  readonly accionesTotales: PermisoAccion[] = [this.verDetalle, this.anular];

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  dataList: DataApi[] = [];

  dialogPopUp: boolean = false;
  activateChangeFn: boolean = false;
  showModalViewDetail: boolean = false;
  showPopUpReport: boolean = false;

  now: string = moment().format('YYYY-MM-DD');
  msgReport: string = '';

  numConfirmations: number = 0;

  confirmationData: Record<string, string> = {
    atenumero: '',
    ateestado: '',
    title: '',
    msgConfirmation: '',
  };

  data: DataApi = {};
  status: FiltersApi[] = [];
  objectParam: ParamsApi = {
    start_date: moment().subtract(1, 'month'),
    end_date: moment(),
    ndvnumero: '',
    ateestado: '',
    ndvnombre: '',
  };
  currentObjectParam: ParamsApi = {};
  timeout: { timeout: number } = { timeout: 3000 };
  accion: string;
  fecha_facturacion: string | moment.Moment = moment();
  mostrarHijo: boolean = false;
  constructor() {
    super();
    // this.generaActionsEvent();
    this.columnDefs = this.colsGrid();
    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  mounted() {
    this.generaActionsEvent();
  }

  generaActionsEvent() {
    actionsEvent.onVerDetalle(this.handleViewDetail);
    actionsEvent.onFacturar(this.handleFacturar);
    actionsEvent.onAnular(this.handleCancel);
  }
  colsGrid(): ColDef[] {
    const cols = [
      { field: 'Número', id: 'atenumero' },
      { field: 'Estado', id: 'ateestado' },
      { field: 'Nota de Venta', id: 'ndvnombre' },
      { field: 'Número INET', id: 'atenumero_inet' },
      { field: 'Fecha INET', id: 'atefecha_atencion' },
      { field: 'Fecha de Emisión', id: 'atefecha_emision' },
      { field: 'Fecha Facturación', id: 'atefecha_facturado' },
      { field: 'Razón Social Cliente', id: 'atecliente_rut' },
      { field: 'RUT Cliente', id: 'atecliente_nombre' },
      { field: 'Dirección', id: 'atecliente_direccion' },
      { field: 'Comuna', id: 'atecliente_comuna' },
      { field: 'Ciudad', id: 'atecliente_ciudad' },
      { field: 'Teléfono', id: 'atecliente_telefono' },
      { field: 'Email', id: 'atecliente_email' },
      { field: 'Giro', id: 'atecliente_giro' },
      { field: 'Documento', id: 'atedocumento_agenerar' },
      { field: 'Neto Productos', id: 'ateneto_producto' },
      { field: '% Descuento', id: 'atedescuento_porcien' },
      { field: 'Monto Descuento', id: 'atedescuento_monto' },
      { field: 'Neto Afecto', id: 'ateneto_afecto' },
      { field: 'IVA', id: 'ateiva' },
      { field: 'Total', id: 'atetotal' },
      { field: 'Estado Transmisión', id: 'ateestado_transmision' },
      { field: 'Usuario Modifica', id: 'usuario_modifica' },
      { field: 'Fecha Anula', id: 'atefecha_anula' },
    ];

    return cols.map(col => {
      let cb = null;
      if (col.id === 'ateestado') {
        cb = {
          cellRenderer: (params: any) =>
            this.iconState({ ateestado: params.data.ateestado }),
        };
      }
      if (col.id === 'atenumero') {
        cb = {
          headerCheckboxSelection: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          ...cb,
        };
      }
      return {
        headerName: col.field,
        field: col.id,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 220,
        minWidth: 100,
        ...cb,
      };
    });
  }

  iconState({ ateestado }: IdParams): string {
    return `<i class="material-icons" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
      ateestado.toLowerCase() === 'emitida'
        ? 'rgb(255 242 38)'
        : ateestado.toLowerCase() === 'facturada' ||
          ateestado.toLowerCase() === 'transmitida'
        ? 'rgb(42 255 78)'
        : 'rgb(255 58 58)'
    }"></i>
      <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${ateestado}</a>`;
  }

  async handleMainGridReady(event: GridReadyEvent): Promise<void> {
    this.status = await this.getFilters();
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.reloadGrid({});
  }

  async reloadGrid({ clear = false }: ClearParam): Promise<void> {
    clear && this.clear();
    this.dataList = await this.getAll();
    this.gridApi.setRowData(this.dataList);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleShowPopUp(confirmation: boolean): void {
    if (!confirmation) {
      this.mostrarHijo = false;
      return this.clearDataPopUp();
    }
    this.numConfirmations++;
    this.validateSatateValue({
      numConfirmations: this.numConfirmations,
      atenumero: this.confirmationData.atenumero,
      ateestado: this.confirmationData.ateestado,
      accion: this.accion,
    });
  }

  validateSatateValue({
    numConfirmations,
    atenumero,
    ateestado,
    accion,
  }: IdParams): void {
    if (accion === 'anular') {
      this.enviaAnular({
        numConfirmations,
        atenumero,
        ateestado,
      });
    }
    if (accion === 'facturar') {
      this.enviarFacturar({
        numConfirmations,
        atenumero,
        ateestado,
      });
    }
    if (accion === 'anular_masivo') {
      this.enviarAnularMasivo({
        numConfirmations,
        atenumero,
        ateestado,
      });
    }
    if (accion === 'facturar_masivo') {
      this.enviarFacturarMasivo({
        numConfirmations,
        atenumero,
        ateestado,
      });
    }
  }
  enviaAnular(params: any): void {
    const anulada = this.validaEstado(params);
    if (anulada) return;
    this.validaEstado(params);
    if (params.numConfirmations === 1) {
      this.dialogPopUp = false;
      this.confirmationData.title = `Anular Atención Nro ${params.atenumero}`;
      this.confirmationData.msgConfirmation = `¿Está seguro que desea anular la atención Nro ${params.atenumero}?`;
      setTimeout(() => (this.dialogPopUp = true), 800);
      return;
    }
    if (params.numConfirmations === 2) {
      this.updateEstado({
        atenumero: params.atenumero,
        ateestado: params.ateestado,
        accion: 'anular',
      });
      this.clearDataPopUp();
      return;
    }
    this.clearDataPopUp();
  }
  enviarFacturar(params: any): void {
    const facturada = this.validaEstado(params);
    if (facturada) return;
    if (params.numConfirmations === 1) {
      this.dialogPopUp = false;
      this.mostrarHijo = true;
      this.confirmationData.title = `Facturar Atención Nro ${params.atenumero}`;
      this.confirmationData.msgConfirmation = `¿Está seguro que desea facturar la atención Nro ${params.atenumero}?`;
      setTimeout(() => (this.dialogPopUp = true), 800);
      return;
    }
    if (params.numConfirmations === 2) {
      this.updateEstado({
        atenumero: params.atenumero,
        ateestado: params.ateestado,
        accion: 'facturar',
      });
      this.clearDataPopUp();
      return;
    }
    this.mostrarHijo = false;
    this.clearDataPopUp();
  }
  anular_masivo(): void {
    const selectedRows = this.gridApi.getSelectedRows();
    if (selectedRows.length === 0) {
      this.$snotify.error('Debe seleccionar al menos una atención', {
        ...this.timeout,
      });
      return;
    }
    this.confirmationData = {
      title: `Confirmación PLataforma INET`,
      msgConfirmation: `¿Confirma que la atenciones ya fueron anuladas en la plataforma INET?`,
    };
    this.accion = 'anular_masivo';
    this.dialogPopUp = true;
  }
  enviarAnularMasivo(params: any): void {
    // const facturada = this.validaEstado(params);
    // if (facturada) return;
    if (params.numConfirmations === 1) {
      this.dialogPopUp = false;
      // this.mostrarHijo = true;
      this.confirmationData.title = `Anulación Masiva`;
      this.confirmationData.msgConfirmation = `¿Está seguro que desea anular la atenciones seleccionadas?`;
      setTimeout(() => (this.dialogPopUp = true), 800);
      return;
    }
    if (params.numConfirmations === 2) {
      this.updateEstado({
        atenumero: params.atenumero,
        ateestado: params.ateestado,
        accion: this.accion,
      });
      this.clearDataPopUp();
      this.mostrarHijo = false;
      return;
    }
    this.mostrarHijo = false;
    this.clearDataPopUp();
  }
  enviarFacturarMasivo(params: any): void {
    // const facturada = this.validaEstado(params);
    // if (facturada) return;
    if (params.numConfirmations === 1) {
      this.dialogPopUp = false;
      this.mostrarHijo = true;
      this.confirmationData.title = `Facturación Masiva`;
      this.confirmationData.msgConfirmation = `¿Está seguro que desea facturar la atenciones seleccionadas?`;
      setTimeout(() => (this.dialogPopUp = true), 800);
      return;
    }
    if (params.numConfirmations === 2) {
      this.updateEstado({
        atenumero: params.atenumero,
        ateestado: params.ateestado,
        accion: this.accion,
      });
      this.clearDataPopUp();
      this.mostrarHijo = false;
      return;
    }
    this.mostrarHijo = false;
    this.clearDataPopUp();
  }
  facturar_masivo(): void {
    const selectedRows = this.gridApi.getSelectedRows();
    if (selectedRows.length === 0) {
      this.$snotify.error('Debe seleccionar al menos una atención', {
        ...this.timeout,
      });
      return;
    }
    this.confirmationData = {
      title: `Confirmación PLataforma INET`,
      msgConfirmation: `¿Confirma que la atenciones ya fueron facturadas en la plataforma INET?`,
    };
    this.accion = 'facturar_masivo';
    this.dialogPopUp = true;
  }

  validaEstado(params: any) {
    if (
      params.ateestado.toLowerCase() == 'facturada' ||
      params.ateestado.toLowerCase() == 'anulada'
    ) {
      this.$snotify.error(
        `La Atención Nro ${params.atenumero} ya se encuentra con estado Anulada o Facturada`,
        { ...this.timeout }
      );
      this.clearDataPopUp();
      return true;
    }
  }
  handleFilters(): void {
    if (
      this.objectParam.ndvnumero &&
      this.objectParam.ndvnumero !== this.currentObjectParam.ndvnumero
    ) {
      this.activateChangeFn = false;
      return;
    }
    if (this.objectParam.ndvnumero === this.currentObjectParam.ndvnumero) {
      this.reloadGrid({});
      return;
    }
    if (this.activateChangeFn || this.objectParam.ndvnumero === null) {
      this.objectParam.ndvnumero = '';
      this.reloadGrid({});
      return;
    }
  }

  handleSearchFilter(): void {
    if (
      this.objectParam.ndvnumero &&
      this.objectParam.ndvnumero !== this.currentObjectParam.ndvnumero
    ) {
      this.activateChangeFn = false;
      this.currentObjectParam = { ...this.objectParam };
      this.reloadGrid({});
      return;
    }
    this.activateChangeFn = true;
    this.currentObjectParam = { ...this.objectParam };
    this.reloadGrid({});
  }

  handleViewDetail(params: any) {
    // console.log('params', params);
    this.data = params.data;
    this.showModalViewDetail = true;
  }

  handleCancel(params: any) {
    const { atenumero, ateestado } = params.data;
    this.confirmationData = {
      atenumero,
      ateestado,
      title: `Confirmación PLataforma INET`,
      msgConfirmation: `¿Confirma que la atención Nro ${atenumero} ya fue anulada en la plataforma INET?`,
    };
    this.dialogPopUp = true;
    this.accion = 'anular';
  }
  handleFacturar(params: any) {
    const { atenumero, ateestado } = params.data;
    this.confirmationData = {
      atenumero,
      ateestado,
      title: `Confirmación PLataforma INET`,
      msgConfirmation: `¿Confirma que la atención Nro ${atenumero} ya fue facturada en la plataforma INET?`,
    };
    this.dialogPopUp = true;
    this.accion = 'facturar';
  }
  handleClosedModal() {
    this.showModalViewDetail = false;
    this.data = {};
  }

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  preventMinusKey(event: KeyboardEvent): void {
    const { key } = event;
    // Permitir tecla de retroceso
    if (['Backspace', 'Shift', 'ArrowLeft', 'ArrowRight'].includes(key)) {
      return;
    }

    // Permitir solo números enteros positivos
    if (key === 'Dead') {
      event.preventDefault();
      return;
    }

    const isValid = /^\d+$/.test(key);

    if (!isValid) {
      event.preventDefault();
    }
  }

  clear(): void {
    Object.keys(this.objectParam).forEach(
      key =>
        (this.objectParam[key as keyof ParamsApi] =
          key === 'start_date'
            ? (moment().subtract(1, 'month') as any)
            : key === 'end_date'
            ? moment()
            : '')
    );
    this.activateChangeFn = false;
    this.currentObjectParam = {};
  }

  clearDataPopUp(): void {
    this.dialogPopUp = false;
    this.numConfirmations = 0;
    Object.keys(this.confirmationData).forEach(
      key => (this.confirmationData[key] = '')
    );
  }

  @Watch('objectParam.start_date')
  startDateChange() {
    if (this.objectParam.start_date > this.objectParam.end_date) {
      this.objectParam.end_date = this.objectParam.start_date;
    }
    this.handleFilters();
  }

  @Watch('objectParam.end_date')
  endDateChange() {
    if (this.objectParam.end_date < this.objectParam.start_date) {
      this.objectParam.start_date = this.objectParam.end_date;
    }
    this.handleFilters();
  }

  validateError({ msg }: MsgParam): void {
    if (msg === 'Request failed with status code 500') {
      this.$snotify.error(
        'El servicio no se encuentra disponible, por favor intente más tarde',
        { ...this.timeout }
      );
    } else {
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { ...this.timeout }
      );
    }
    throw msg;
  }

  async getAll(): Promise<DataApi[]> {
    this.loadingService.showLoading();
    const self = this;
    return await fetchAtenciones({ body: { ...this.objectParam } })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;

        if (CODIGO_RESPUESTA != '1' || MENSAJE_RESPUESTA) {
          self.$snotify.error(MENSAJE_RESPUESTA, { ...self.timeout });
          return [];
        }
        return LISTA;
      })
      .catch((err: Error) => {
        err instanceof Error && self.validateError({ msg: err.message });
        throw err;
      })
      .finally(() => self.loadingService.hideLoading());
  }

  async getFilters(): Promise<FiltersApi[]> {
    this.loadingService.showLoading();
    const self = this;
    return await fetchAtenciones({ endpoint: 'get_filters' })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;
        if (CODIGO_RESPUESTA != '1' || MENSAJE_RESPUESTA) {
          self.$snotify.error(MENSAJE_RESPUESTA, { ...self.timeout });
          return [];
        }
        return LISTA;
      })
      .catch(
        (err: Error) =>
          err instanceof Error && self.validateError({ msg: err.message })
      )
      .finally(() => self.loadingService.hideLoading());
  }

  async getCSV(): Promise<void> {
    this.loadingService.showLoading();
    const userId = getUserId();
    const user = localStorage.getItem('clienteDefecto');
    const self: this = this;

    return await fetchAtenciones({
      endpoint: 'export_excel',
      body: {
        userId,
        user,
        ...self.objectParam,
      },
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          return self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        }
        self.msgReport = MENSAJE_RESPUESTA;
        self.showPopUpReport = true;
      })
      .catch(
        (err: Error) =>
          err instanceof Error && self.validateError({ msg: err.message })
      )
      .finally(() => self.loadingService.hideLoading());
  }

  async updateEstado({
    atenumero,
    ateestado,
    accion,
  }: IdParams): Promise<void> {
    this.loadingService.showLoading();
    const self = this;
    let fecha = moment(this.fecha_facturacion).format('YYYY-MM-DD HH:mm:ss');
    let body: { [key: string]: any } = {
      userId: getUserId(),
      atenumero,
      ateestado,
      accion: this.accion,
      fecha_facturacion: fecha,
    };

    if (this.accion === 'facturar_masivo' || this.accion === 'anular_masivo') {
      body.atenciones = this.gridApi.getSelectedRows();
    }
    console.log('body', body);
    return await fetchAtenciones({
      endpoint: accion,
      body: body,
    })
      .then(response => {
        const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA } = response.data;

        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { ...self.timeout });
        } else {
          self.$snotify.success(MENSAJE_RESPUESTA, { ...self.timeout });
        }
        self.reloadGrid({});
      })
      .catch(
        (err: Error) =>
          err instanceof Error && self.validateError({ msg: err.message })
      )
      .finally(() => self.loadingService.hideLoading());
  }
}
